import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/tailwind.css'
import md5 from 'md5'
// 引入JSBridge
import './utils/jsBridge.js'
/* eslint-disable */
// var vConsole = new window.VConsole();

const app = createApp(App)
app.use(router)
// 全局挂载md5方法
app.config.globalProperties.$md5 = md5
app.mount('#app')
